import MainLayout from 'layouts/MainLayout';
import { Navigate, RouteObject, createBrowserRouter } from 'react-router-dom';
import BasicTableExample from 'pages/modules/tables/BasicTableExample';
import Ecommerce from 'pages/dashboard/ecommerce';
import MainLayoutProvider from 'providers/MainLayoutProvider';
import AdvanceTableExample from 'pages/modules/tables/AdvanceTableExample';
import App from 'App';
import CardSignIn from 'pages/pages/authentication/card/SignIn';
import CardSignUp from 'pages/pages/authentication/card/SignUp';
import CardForgotPassword from 'pages/pages/authentication/card/ForgotPassword';
import CardSignOut from 'pages/pages/authentication/card/SignOut';
import CardResetPassword from 'pages/pages/authentication/card/ResetPassword';
import CardTwoFA from 'pages/pages/authentication/card/TwoFA';
import CardLockScreen from 'pages/pages/authentication/card/LockScreen';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import NotificationMessage from 'pages/pages/authentication/card/NotificationMessage';
import GetProperties from '../../src/PropertiesView/GetProperties';
import Homepage from 'LandingPage/Homepage';
import PropertyPage from 'PropertiesView/PropertyPage';
// import ShortUrlRedirect from 'PropertiesView/ShortUrlRedirect';
import AgentPropertyView from 'components/AgentView/AgentPropertyView';
import AgentCreateProperty from 'components/AgentView/AgentCreateProperty';
import LeadDeals from 'components/modules/crm/LeadDeals';
import UserLeads from 'PropertiesViewPage/LeadDetails';

// const routes: RouteObject[] = [
//   {
//     element: <App />,
//     children: [
//       {
//         path: '/',
//         element: <PrivateRoute />,
//         children: [
//           {
//             element: (
//               <MainLayoutProvider>
//                 <MainLayout />
//               </MainLayoutProvider>
//             ),
//             children: [
//               {
//                 index: true,
//                 element: <Ecommerce />
//               },

//               {
//                 path: '/dashboard',
//                 children: [
//                   {
//                     path: 'properties',
//                     element: <AgentPropertyView />
//                   },
//                   {
//                     path: 'properties/:id',
//                     element: <PropertyPage />
//                   },
//                   {
//                     path: 'properties/createProperty',
//                     element: <AgentCreateProperty />
//                   },

//                   {
//                     path: '*',
//                     element: <Navigate to="/" replace />
//                   }
//                 ]
//               },
//               {
//                 path: ':shortUrl',
//                 element: <ShortUrlRedirect />
//               },
//               {
//                 path: '*',
//                 element: <Navigate to="/" replace />
//               },
//               {
//                 path: '/modules',
//                 children: [
//                   {
//                     path: 'tables',
//                     children: [
//                       {
//                         path: 'basic-tables',
//                         element: <BasicTableExample />
//                       },
//                       {
//                         path: 'advance-tables',
//                         element: <AdvanceTableExample />
//                       }
//                     ]
//                   }
//                 ]
//               }
//             ]
//           }
//         ]
//       },

//       {
//         path: '/',
//         element: <PublicRoute />,
//         children: [
//           {
//             path: 'Homepage',
//             element: <Homepage />
//           },
//           {
//             path: 'sign-in',
//             element: <CardSignIn />
//           },
//           {
//             path: 'sign-up',
//             element: <CardSignUp />
//           },
//           {
//             path: 'sign-out',
//             element: <CardSignOut />
//           },
//           {
//             path: 'forgot-password',
//             element: <CardForgotPassword />
//           },
//           {
//             path: 'reset-password/:token',
//             element: <CardResetPassword />
//           },
//           {
//             path: 'notification',
//             element: <NotificationMessage />
//           },
//           {
//             path: 'lock-screen',
//             element: <CardLockScreen />
//           },
//           {
//             path: '2FA',
//             element: <CardTwoFA />
//           },
//           {
//             path: '*',
//             element: <CardSignIn />
//           }
//         ]
//       }
//     ]
//   }
// ];

// const routes: RouteObject[] = [
//   {
//     element: <App />,
//     children: [
//       {
//         path: '/',
//         element: <PrivateRoute />,
//         children: [
//           {
//             element: (
//               <MainLayoutProvider>
//                 <MainLayout />
//               </MainLayoutProvider>
//             ),
//             children: [
//               {
//                 index: true,
//                 element: <Ecommerce />
//               },

//               {
//                 path: '/dashboard',
//                 children: [
//                   {
//                     path: 'properties',
//                     element: <AgentPropertyView />
//                   },
//                   {
//                     path: 'properties/createProperty',
//                     element: <AgentCreateProperty />
//                   },
//                   {
//                     path: '*',
//                     element: <Navigate to="/dashboard/properties" replace />
//                   }
//                 ]
//               },
//               {
//                 path: '*',
//                 element: <Navigate to="/dashboard/properties" replace />
//               },
//               {
//                 path: '/modules',
//                 children: [
//                   {
//                     path: 'tables',
//                     children: [
//                       {
//                         path: 'basic-tables',
//                         element: <BasicTableExample />
//                       },
//                       {
//                         path: 'advance-tables',
//                         element: <AdvanceTableExample />
//                       }
//                     ]
//                   }
//                 ]
//               }
//             ]
//           }
//         ]
//       },

//       {
//         path: '/',
//         element: <PublicRoute />,
//         children: [
//           {
//             path: '/Homepage',
//             element: <Homepage />
//           },
//           {
//             path: 'sign-in',
//             element: <CardSignIn />
//           },
//           {
//             path: 'sign-up',
//             element: <CardSignUp />
//           },
//           {
//             path: 'sign-out',
//             element: <CardSignOut />
//           },
//           {
//             path: 'forgot-password',
//             element: <CardForgotPassword />
//           },
//           {
//             path: 'reset-password/:token',
//             element: <CardResetPassword />
//           },
//           {
//             path: 'notification',
//             element: <NotificationMessage />
//           },
//           {
//             path: 'lock-screen',
//             element: <CardLockScreen />
//           },
//           {
//             path: '2FA',
//             element: <CardTwoFA />
//           },
//           {
//             path: '*',
//             element: <CardSignIn />
//           }
//         ]
//       },

//       {
//         path: '/property/:id',
//         element: <PropertyPage />
//       },
//       {
//         path: '/lead-details',
//         element: <UserLeads />
//       },

//       // {
//       //   path: ':shortUrl',
//       //   element: <ShortUrlRedirect />
//       // }
//       {
//         path: '*',
//         element: <Navigate to="/" replace />
//       }
//     ]
//   }
// ];

const routes: RouteObject[] = [
  {
    element: <App />,
    children: [
      {
        path: '/',
        element: <PublicRoute />,
        children: [
          {
            index: true, 
            element: <Homepage />
          },
          {
            path: 'sign-in',
            element: <CardSignIn />
          },
          {
            path: 'sign-up',
            element: <CardSignUp />
          },
          {
            path: 'sign-out',
            element: <CardSignOut />
          },
          {
            path: 'forgot-password',
            element: <CardForgotPassword />
          },
          {
            path: 'reset-password/:token',
            element: <CardResetPassword />
          },
          {
            path: 'notification',
            element: <NotificationMessage />
          },
          {
            path: 'lock-screen',
            element: <CardLockScreen />
          },
          {
            path: '2FA',
            element: <CardTwoFA />
          }
        ]
      },

      // ✅ PRIVATE ROUTES (Dashboard, Modules, etc.)
      {
        path: '/dashboard',
        element: <PrivateRoute />,
        children: [
          {
            element: (
              <MainLayoutProvider>
                <MainLayout />
              </MainLayoutProvider>
            ),
            children: [
              {
                index: true,
                element: <Navigate to="properties" replace />
              },
              {
                path: 'properties',
                element: <AgentPropertyView />
              },
              {
                path: 'properties/createProperty',
                element: <AgentCreateProperty />
              },
              {
                path: '*',
                element: <Navigate to="properties" replace />
              }
            ]
          }
        ]
      },

      {
        path: '/modules',
        element: <PrivateRoute />,
        children: [
          {
            path: 'tables',
            children: [
              {
                path: 'basic-tables',
                element: <BasicTableExample />
              },
              {
                path: 'advance-tables',
                element: <AdvanceTableExample />
              }
            ]
          }
        ]
      },

      // Public Access Pages
      {
        path: '/property/:id',
        element: <PropertyPage />
      },
      {
        path: '/lead-details',
        element: <UserLeads />
      },

      // Catch-all fallback
      {
        path: '*',
        element: <Navigate to="/" replace />
      }
    ]
  }
];


export const router = createBrowserRouter(routes);

export default routes;
